module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('setting-title', {
    attrs: {
      "title": "过滤规则",
      "description": "排除特定受访URL、来源URL、来源访客IP的访问，使分析报告中不包含此部分流量",
      "date": _vm.timeSpan
    }
  }, [_c('div', {
    attrs: {
      "id": "backToReport"
    }
  }, [_vm._v("完成本页操作后可"), _c('router-link', {
    attrs: {
      "to": "/web/overview"
    }
  }, [_vm._v("查看分析")])], 1)]), _c('div', {
    staticClass: "zone content-part"
  }, [_c('domain-select', {
    attrs: {
      "extra": "为网站$domain绑定过滤规则"
    },
    on: {
      "change": _vm.onDomainChange
    }
  })], 1), _c('timeSpan', {
    on: {
      "change": _vm.onTimespanChange
    }
  }), _c('FilterTable', {
    attrs: {
      "addText": "添加排除受访URL",
      "firstColText": "排除的受访URL",
      "placeHolder": "请填写排除受访URL",
      "pattern": "url",
      "urltype": "nourl",
      "params": _vm.params
    },
    on: {
      "listHistory": _vm.showHistoryInfo
    }
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-diamond",
      "title": "排除受访"
    },
    slot: "icon"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s("（添加删除后实时生效）"))])])], 1), _c('FilterTable', {
    attrs: {
      "addText": "添加排除来源URL",
      "firstColText": "排除的来源URL",
      "placeHolder": "请填写排除来源URL",
      "pattern": "url",
      "urltype": "norefurl",
      "params": _vm.params
    },
    on: {
      "listHistory": _vm.showHistoryInfo
    }
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-diamond",
      "title": "排除来源"
    },
    slot: "icon"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s("（添加删除后实时生效）"))])])], 1), _c('FilterTable', {
    attrs: {
      "addText": "添加排除访客IP",
      "firstColText": "排除的访客IP",
      "placeHolder": "请填写排除访客IP",
      "pattern": "ip",
      "urltype": "noip",
      "params": _vm.params
    },
    on: {
      "listHistory": _vm.showHistoryInfo
    }
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-diamond",
      "title": "排除访客IP列表"
    },
    slot: "icon"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s("（添加删除后实时生效）"))])])], 1), _c('v-modal', {
    ref: "historyModal",
    attrs: {
      "visible": _vm.historyInfoVisible,
      "title": "历史数据"
    },
    on: {
      "closemodal": function($event) {
        _vm.historyInfoVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-bd"
  }, [_c('div', {
    staticClass: "modal-content history-content"
  }, [(_vm.historyInfoVisible) ? _c('data-table', {
    attrs: {
      "url": _vm.historyApi
    },
    on: {
      "getdata": _vm.setHistoryList
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("日期")]), _c('th', [_vm._v("PV")])])]), _c('tbody', _vm._l((_vm.historyData), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("toDate")(row.date)) + " ")]), _c('td', [_vm._v(_vm._s(row.pv))])])
  }))]) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e5b92d6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e5b92d6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/filter.vue
// module id = 740
// module chunks = 0